import romanPic from "@/public/images/artists/roman.png";
import { Artist } from "@/types/types";

export const roman = {
  id: "182",
  name: "Roman",
  image: romanPic,
  description: `Roman's baritone is rich, warm, and effortlessly grounding. There's a balanced, composed edge to his tone that brings a steady presence—spot-on for soulful vibes or introspective moods.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Froman-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Folk", "Soul", "Blues", "Soundtrack"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 45,
        high: 71,
      },
      sweetSpot: 59,
    },
  },
} as const satisfies Artist;
